import { z } from 'zod';

const clientResponseSchemas = {
  getAllClients: z.object({
    success: z.boolean(),
    message: z.string(),
    data: z.array(
      z.object({
        id: z.number(),
        fullname: z.string(),
      })
    ),
  }),
  associateClientWithSim: z.object({
    success: z.boolean(),
    message: z.string(),
    client: z.object({
      clientId: z.number(),
      clientname: z.string(),
    }),
  }),
} as const;

export default clientResponseSchemas;
